var AUTHORIZATION_TYPE = {
  ACCOUNTANT: 1,
  AUDITOR: 2
};

module.exports = AUTHORIZATION_TYPE;
